import { createImageApi } from './imageApi';
const api = createImageApi('event-images', 'event');
export function uploadEventImage(data) {
    return api.upload(data);
}
export function getEventImages(levelId) {
    return api.list(levelId);
}
export function getArchivedEventImages(levelId) {
    return api.listArchived(levelId);
}
export function archiveEventImage(id) {
    return api.archive(id);
}
export function restoreEventImage(id) {
    return api.restore(id);
}
export function deleteEventImagePermanent(id) {
    return api.deletePermanent(id);
}
